module.exports = __webpack_public_path__ + "img/cash_right.85d46175.png";